import { IconCalendar } from '@calendly/ui/components/glyphs/IconCalendar'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { DetailsItem as Item } from '@calendly/booking-kit'

import { formatEventTime } from 'services/spot_time'


const getEventTime = (startTime, endTime, timezone, timeNotation) => formatEventTime({
  start_time: startTime,
  end_time: endTime
}, timeNotation, timezone)

const EventTime = ({ timeNotation, timezone, source: { start_time: startTime, end_time: endTime }, bookingAppRedesign = false }) => (
  <Item>
    <div>
      <UiIcon icon={IconCalendar} size={bookingAppRedesign ? 'small' : 'medium'} spacingRight="8" data-id="details-item-icon" />
    </div>
    {getEventTime(startTime, endTime, timezone, timeNotation)}
  </Item>
)

export default EventTime
